// extracted by mini-css-extract-plugin
export default {"dailyMealTable":"H5yOHJnXZ_rYureH6KVp"};